import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { useOpenClose } from '@monorepo/shared/hooks/useOpenClose';
import React from 'react';
import { AddSectionModal } from './EditSectionModal/AddSectionModal';
import { AddSectionButton } from './styled';

type AddFormTemplateSectionProps = {
  isAddingDisabled: boolean;
};

export function AddFormTemplateSection({
  isAddingDisabled,
}: AddFormTemplateSectionProps) {
  const [isOpen, openModal, closeModal] = useOpenClose();

  return (
    <>
      <AddSectionButton onClick={openModal} disabled={isAddingDisabled}>
        <AddCircleOutlineIcon fontSize="small" />
        Add new section
      </AddSectionButton>
      <AddSectionModal isOpen={isOpen} onClose={closeModal} />
    </>
  );
}
